import { render } from "./OtherWatchesRandom.vue?vue&type=template&id=11a3c6e8"
import script from "./OtherWatchesRandom.vue?vue&type=script&lang=js"
export * from "./OtherWatchesRandom.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__